import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const ExpertiseIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_14834_6765"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="29"
        height="29"
      >
        <path d="M0 0.146006H28.2798V28.4258H0V0.146006Z" fill="white" />
      </mask>
      <g mask="url(#mask0_14834_6765)">
        <path
          d="M27.1759 12.1126L14.1407 1.24989L1.10547 12.1126V27.3203H13.5883"
          stroke="currentColor"
          strokeWidth="1.3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.6602 17.9635C20.6602 17.9635 21.7551 16.3122 23.919 16.3122C25.8482 16.3122 27.1778 18.0074 27.1778 19.9816C27.1778 22.2667 25.3654 24.9704 20.6602 27.3203C15.955 24.9704 14.1426 22.2667 14.1426 19.9816C14.1426 18.0074 15.4722 16.3122 17.4014 16.3122C19.5652 16.3122 20.6602 17.9635 20.6602 17.9635Z"
          stroke="currentColor"
          strokeWidth="1.3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
})

ExpertiseIcon.displayName = 'ExpertiseIcon'
